import { rsaEncryptByPublicKey } from './util'
import { isString, isObject } from './types'
import { md5 } from './md5'

// 解析ajax请求中的url参数或post参数
function parseRequestData(data) {
	let buffer = []
	let idx = data.lastIndexOf('?')
	if (idx > -1) {
		data = data.substring(idx + 1, data.length)
	}

	// 处理+号，由于+号在XMLHttpRequest里send时会变成空格，因此计算时需要替换为空格，保持与后端一致
	data = data.replace(/\+/g, ' ')

	let arr = data.split('&')
	if (arr && arr.length) {
		let item, k, v
		for (let i = 0; i < arr.length; i++) {
			item = arr[i]
			if (item && isString(item)) {
				idx = item.indexOf('=')
				k = item
				v = ''
				if (idx > -1) {
					k = item.substring(0, idx)
					v = item.substring(idx + 1, item.length)
				}
				// 判断value中是否有%号，有则做decodeURIComponent
				if (v && v.indexOf('%') > -1) {
					v = decodeURIComponent(v)
				}
				buffer.push(k + '=' + v)
			}
		}
	}

	return buffer
}

/**
 * axios接口参数签名
 * @param {*} config 请求配置
 */
export function axiosSign(config) {
	// 获取到秒级的时间戳,与后端对应
	let time = new Date().valueOf()
	// 校准时间
	if (window.timestampDifference) {
		time -= window.timestampDifference
	}
	let pArray = []
	if (config.url && config.url.indexOf('?') > -1) {
		pArray = parseRequestData(config.url)
	}
	let signStr = ''
	if (config.params) {
		// url参数签名
		for (let p in config.params) {
			pArray.push(p + '=' + config.params[p])
		}
	} else if (config.data) {
		if (config.data instanceof FormData) {
			for (let [key, value] of config.data) {
				if (!(value instanceof File)) {
					pArray.push(key + '=' + value)
				}
			}
		} else {
			// request body参数的内容
			pArray.push(JSON.stringify(config.data))
		}
	}
	pArray.sort() // 排序
	signStr = pArray.join('&')
	// console.debug('axiosSign origin sign str', signStr)
	signStr = encodeURIComponent(signStr)
	// console.debug('axiosSign encode sign str', signStr)
	let hash = md5(signStr)
	let headers = config.headers || {}
	let signature = hash + '|' + time
	let rsaSignature = rsaEncryptByPublicKey(signature)
	headers.Signature = rsaSignature
	headers['X-Requested-Sign'] = rsaSignature
	// console.debug('axiosSign:' + signature)
	config = Object.assign(config, { headers: headers })
	return config
}

/**
 * filetransfer 参数签名
 * @param settings
 * @param file
 */
export function transferSign(settings) {
	let time = new Date().valueOf()
	// 校准时间
	if (window.timestampDifference) {
		time -= window.timestampDifference
	}
	let pArray = []
	if (settings && settings.url && settings.url.indexOf('?') > -1) {
		pArray = parseRequestData(settings.url)
	}

	let signStr = ''
	if (settings.data) {
		// url参数签名
		for (let p in settings.data) {
			pArray.push(p + '=' + settings.data[p])
		}
	}
	pArray.sort() // 排序
	signStr = pArray.join('&')
	signStr = encodeURIComponent(signStr)
	let hash = md5(signStr)
	let headers = settings.headers || {}
	let signature = hash + '|' + time
	let rsaSignature = rsaEncryptByPublicKey(signature)
	headers.Signature = rsaSignature
	headers['X-Requested-Sign'] = rsaSignature
	settings = Object.assign(settings, { headers: headers })
	return settings
}

/**
 * ajax 请求签名
 * @param url
 * @param data
 * @returns {*}
 */
export function ajaxSign(url, data, xhr, useFormdata) {
	let time = new Date().valueOf()
	// 校准时间
	if (window.timestampDifference) {
		time -= window.timestampDifference
	}

	let pArray = []
	if (url && url.indexOf('?') > -1) {
		pArray = parseRequestData(url)
	}

	let signStr = ''
	if (data) {
		if (isString(data)) {
			pArray = pArray.concat(parseRequestData(data))
		} else if (isObject(data)) {
			if (useFormdata === true) {
				// 使用表单数据模式
				if (data instanceof FormData) {
					for (let [key, value] of data) {
						if (!(value instanceof File)) {
							pArray.push(key + '=' + value)
						}
					}
				} else {
					for (let p in data) {
						pArray.push(p + '=' + data[p])
					}
				}
			} else {
				// 使用整个requestBody模式
				pArray.push(JSON.stringify(data))
			}
		}
	}
	pArray.sort() // 排序
	signStr = pArray.join('&')
	// console.debug('ajaxSign useFormdata:' + useFormdata)
	// console.debug('ajaxSign origin sign str', signStr)
	signStr = encodeURIComponent(signStr)
	// console.debug('ajaxSign encode sign str', signStr)
	let hash = md5(signStr)
	let signature = hash + '|' + time
	// console.debug('ajaxSign:' + signature)
	signature = rsaEncryptByPublicKey(signature)
	if (xhr && xhr instanceof XMLHttpRequest) {
		xhr.setRequestHeader('Signature', signature)
		xhr.setRequestHeader('X-Requested-Sign', signature)
	}
	return signature
}
